import { put, select, takeLatest } from 'redux-saga/effects';
import * as qs from 'querystring';
import { LOCATION_CHANGE, LocationChangeAction, replace } from 'connected-react-router';
import { actions as appActions } from 'shared/actions/app';
import { actions } from 'actions';
import { Money } from 'shared/types/common';
import { isAuthenticated as isAuthenticatedSelector } from 'shared/selectors/app';

export function* modals() {
  yield takeLatest(LOCATION_CHANGE, function* ({ payload }: LocationChangeAction) {
    const query = payload.location.search;
    const params = qs.parse(query.substr(1));
    if (!params) {
      return;
    }

    const { action, value, currency, ...rest } = params;

    const amount = parseAmount({ value, currency });

    if (action) {
      yield put(
        replace(
          payload.location.pathname + (Object.keys(rest).length ? '?' + qs.stringify(rest) : '')
        )
      );
    }

    const { isAuthenticated }: ReturnType<typeof isAuthenticatedSelector> = yield select(
      isAuthenticatedSelector
    );

    if (!isAuthenticated) {
      return;
    }

    switch (params.action) {
      case 'deposit':
        // @ts-ignore
        return yield put(appActions.showDepositModal(amount));
      case 'withdraw':
        // @ts-ignore
        return yield put(appActions.showWithdrawModal(amount.currency));
      case 'conversion':
        // @ts-ignore
        return yield put(actions.showExchangeModal(amount.currency, amount.value));
    }
  });
}

interface QueryStringAmount {
  value?: string | string[];
  currency?: string | string[];
}

const parseAmount = ({ value, currency }: QueryStringAmount): Money => ({
  value: value && !Array.isArray(value) && !isNaN(+value) ? +value : 0,
  currency: currency && !Array.isArray(currency) ? currency.toUpperCase() : 'USD',
});
